import { Availability, AvailabilityInterval } from 'types'
import { CalendarPageAvailabilitySlot } from 'components/calendar-page/calendar-page-availability-slot/calendar-page-availability-slot'
import { getIsoStringYearMonthDay } from 'utils'
import { theme } from 'antd'

type Props = {
    currentDay: Date
    availabilities: Availability[]
    dayStartHour: number
    scale: number
}

export const CalendarPageAvailabilityColumn = ({ currentDay, availabilities, dayStartHour, scale }: Props) => {

    const { token: { colorFillQuaternary } } = theme.useToken()
    
    return (
        <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: colorFillQuaternary,
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            top: 0,
            left: 0
        }}>
            {calcCurrentDayAvailableIntervals(availabilities, currentDay).map(interval => (
                <CalendarPageAvailabilitySlot
                    key={`${interval.from}-${interval.to}`}
                    dayStartHour={dayStartHour}
                    from={interval.from}
                    to={interval.to}
                    scale={scale}
                />
            ))}
        </div>
    )
    
}

const calcCurrentDayAvailableIntervals = (availabilities: Availability[], currentDay: Date) => {

    let intervals: AvailabilityInterval[] = []
    const currentWeekDay = currentDay.toLocaleString(['en-US'], { weekday: 'long' }).toLowerCase()

    // first, map for week rules:
    availabilities.map(availability => {
        if(availability.type === 'wday' && availability.weekday === currentWeekDay){
            intervals = [...availability.intervals]
        }
    })

    // then, map for special days rules(this will override the week rules if needed)
    availabilities.map(availability => {
        if(availability.type === 'date' && availability.date === getIsoStringYearMonthDay(currentDay)){
            intervals = [...availability.intervals]
        }
    })

    return intervals

}
